export function scroll() {
  window.addEventListener("load", () => {
    document.querySelectorAll('a[href^="#"]').forEach((e) =>
      e.addEventListener("click", async function (e) {
        e.preventDefault();
        let target = await e.target.getAttribute("href");
        if (!target) {
          target = await e.target.parentElement.getAttribute("href");
        }
        let targetTop =
          (await document.querySelector(target).getBoundingClientRect().top) +
          window.pageYOffset;
        if (!targetTop) {
          targetTop =
            (await document
              .querySelector(target)
              .parentElement.getBoundingClientRect().top) + window.pageYOffset;
        }
        let scrollOptions = {
          left: 0,
          top: targetTop,
          behavior: "smooth",
        };
        window.scrollTo(scrollOptions);
      })
    );
  });
}
